export type GestaoView = 'kanban' | 'list';

export type GestaoKanbanColumn = 'pending' | 'in_progress' | 'completed' | 'blocked';

export const KANBAN_COLUMNS: Array<{
  id: GestaoKanbanColumn;
  label: string;
  statuses: string[];
  color: string;
}> = [
  { id: 'pending', label: 'Pendentes', statuses: ['pending'], color: 'slate' },
  { id: 'in_progress', label: 'Em Andamento', statuses: ['in_progress'], color: 'blue' },
  { id: 'blocked', label: 'Bloqueadas', statuses: ['failed', 'cancelled'], color: 'red' },
  { id: 'completed', label: 'Concluidas', statuses: ['completed', 'skipped'], color: 'emerald' },
];
